export default {
    WON: 'WON',
    LOST: 'LOST'
}
